var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlisterScan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 90,
    viewBox: "0 0 70 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22.5515,
    y: 11.0121,
    width: 34.1393,
    height: 66.3553,
    rx: 3.60627,
    transform: "rotate(5.43876 22.5515 11.0121)",
    fill: "#E3E3E3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 22.5515,
    y: 11.0121,
    width: 34.1393,
    height: 66.3553,
    rx: 3.60627,
    transform: "rotate(5.43876 22.5515 11.0121)",
    stroke: "#BCBCBC",
    strokeWidth: 0.480836
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.3537 20.7789C36.1523 22.8938 34.2746 24.445 32.1597 24.2437C30.0448 24.0423 28.4936 22.1646 28.695 20.0497C28.8963 17.9348 30.774 16.3836 32.8889 16.5849C35.0038 16.7863 36.5551 18.664 36.3537 20.7789Z",
    fill: "#E7CCCF",
    strokeWidth: 0.961671,
    stroke: "#BCBCBC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1686 33.2243C34.9673 35.3392 33.0896 36.8905 30.9747 36.6891C28.8598 36.4877 27.3085 34.61 27.5099 32.4951C27.7113 30.3802 29.589 28.829 31.7039 29.0304C33.8188 29.2317 35.37 31.1094 35.1686 33.2243Z",
    fill: "#E7CCCF",
    strokeWidth: 0.961671,
    stroke: "#BCBCBC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9836 45.6698C33.7822 47.7847 31.9045 49.3359 29.7896 49.1346C27.6747 48.9332 26.1235 47.0555 26.3248 44.9406C26.5262 42.8257 28.4039 41.2745 30.5188 41.4758C32.6337 41.6772 34.1849 43.5549 33.9836 45.6698Z",
    fill: "#E7CCCF",
    strokeWidth: 0.961671,
    stroke: "#BCBCBC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.799 58.1152C32.5977 60.2301 30.72 61.7813 28.605 61.58C26.4901 61.3786 24.9389 59.5009 25.1403 57.386C25.3416 55.2711 27.2193 53.7199 29.3342 53.9213C31.4491 54.1226 33.0004 56.0003 32.799 58.1152Z",
    fill: "#E7CCCF",
    strokeWidth: 0.961671,
    stroke: "#BCBCBC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.614 70.5607C31.4126 72.6756 29.5349 74.2268 27.42 74.0254C25.3051 73.8241 23.7539 71.9464 23.9552 69.8315C24.1566 67.7166 26.0343 66.1653 28.1492 66.3667C30.2641 66.5681 31.8153 68.4458 31.614 70.5607Z",
    fill: "#E7CCCF",
    strokeWidth: 0.961671,
    stroke: "#BCBCBC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48.799 21.9638C48.5977 24.0787 46.72 25.6299 44.605 25.4286C42.4901 25.2272 40.9389 23.3495 41.1403 21.2346C41.3416 19.1197 43.2193 17.5685 45.3342 17.7699C47.4491 17.9712 49.0004 19.8489 48.799 21.9638Z",
    fill: "#E7CCCF",
    strokeWidth: 0.961671,
    stroke: "#BCBCBC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6144 34.4093C47.4131 36.5242 45.5354 38.0754 43.4205 37.874C41.3056 37.6727 39.7543 35.795 39.9557 33.6801C40.1571 31.5652 42.0348 30.0139 44.1497 30.2153C46.2646 30.4167 47.8158 32.2944 47.6144 34.4093Z",
    fill: "#E7CCCF",
    strokeWidth: 0.961671,
    stroke: "#BCBCBC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4294 46.8547C46.228 48.9696 44.3503 50.5208 42.2354 50.3195C40.1205 50.1181 38.5693 48.2404 38.7706 46.1255C38.972 44.0106 40.8497 42.4594 42.9646 42.6607C45.0795 42.8621 46.6307 44.7398 46.4294 46.8547Z",
    fill: "#E7CCCF",
    strokeWidth: 0.961671,
    stroke: "#BCBCBC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2443 59.3002C45.043 61.4151 43.1653 62.9663 41.0504 62.7649C38.9355 62.5636 37.3842 60.6859 37.5856 58.571C37.787 56.4561 39.6647 54.9048 41.7796 55.1062C43.8945 55.3075 45.4457 57.1852 45.2443 59.3002Z",
    fill: "#E7CCCF",
    strokeWidth: 0.961671,
    stroke: "#BCBCBC"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0593 71.7456C43.8579 73.8605 41.9802 75.4117 39.8653 75.2104C37.7504 75.009 36.1992 73.1313 36.4005 71.0164C36.6019 68.9015 38.4796 67.3503 40.5945 67.5516C42.7094 67.753 44.2606 69.6307 44.0593 71.7456Z",
    fill: "#E7CCCF",
    strokeWidth: 0.961671,
    stroke: "#BCBCBC"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M11 1.75H1.5V10.75",
    strokeWidth: 3,
    stroke: "#244EFF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M68.25 11L68.25 1.5L59.25 1.5",
    strokeWidth: 3,
    stroke: "#244EFF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M2 77.75L2 87.25L11 87.25",
    strokeWidth: 3,
    stroke: "#244EFF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M57 87.75L66.5 87.75L66.5 78.75",
    strokeWidth: 3,
    stroke: "#244EFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlisterScan);
export default __webpack_public_path__ + "static/media/blister-scan.53a799cdccbc7904437b305712a9d617.svg";
export { ForwardRef as ReactComponent };